import { Logs } from '../services/http'

export async function saveLog(message) {
  await Logs().store({ acoes: message })
}
